import { NumberWithUnitsFormatter } from '@ddt-web/data-service';
import { StringUtil } from '@ddt-web/generic-utils';

/**
 * AnnuityHistogramChartTooltip
 */
export class AnnuityHistogramChartTooltip {
	public static getFormatter(customData?: any, displayCurrency: string = '$'): Function {
		const formatter = new NumberWithUnitsFormatter('0', '-', true);
		return function (): string {
			return `<div style="width:180px">
			<b>${StringUtil.escapeHtml(customData.age)}</b> ${StringUtil.escapeHtml(this.point.category)}
			<div>${StringUtil.escapeHtml(this.point.series.name)} <b>${StringUtil.escapeHtml(displayCurrency + formatter.format(Number(this.point.y)))}</b></div></div>`;
		};
	}
}
